import { render, staticRenderFns } from "./SelectParticipants.vue?vue&type=template&id=dd94ba94&scoped=true"
import script from "./SelectParticipants.vue?vue&type=script&lang=js"
export * from "./SelectParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd94ba94",
  null
  
)

export default component.exports